import React from 'react';
import { TabsComponent } from '../../../Components';
import CampaignPerformance from './campaign-performance/CampaignPerformance';
import { PerformanceInsightsTranslationPath } from './i18n/PerformanceInsightsLocale';
import AgentPerformance from './agent-performance/AgentPerformance';
import { PerformanceInsightsPermissions } from '../../../Permissions';

const PerformanceInsightsReports = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  return (
    <div className='w-100'>
      <TabsComponent
        data={[
          {
            label: 'campaign_performance',
            component: CampaignPerformance,
            permissionsList: Object.values(PerformanceInsightsPermissions),
            permissionsId:
              PerformanceInsightsPermissions.ViewCampaignPerformance
                .permissionsId,
          },
          {
            label: 'agent_performance',
            component: AgentPerformance,
            permissionsList: Object.values(PerformanceInsightsPermissions),
            permissionsId:
              PerformanceInsightsPermissions.ViewAgentPerformance.permissionsId,
          },
        ]}
        labelInput={'label'}
        themeClasses={'theme-solid'}
        parentTranslationPath={PerformanceInsightsTranslationPath}
        withDynamicComponents
        currentTab={activeTab}
        onTabChanged={(_e, newTap) => setActiveTab(newTap)}
      />
    </div>
  );
};
export default PerformanceInsightsReports;
